import { PureComponent } from 'react'
import { node, oneOfType, arrayOf } from 'prop-types'
import { reportV2 } from '@/services/api/report'

class ErrorBoundary extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      error: null,
    }
  }
  static getDerivedStateFromError(error) {
    // 更新 state，下次渲染可以展示错误相关的 UI
    return { error: error }
  }

  componentDidCatch(error = {}, info = {}) {
    // 错误上报
    this.setState({
      error: error,
    })

    reportV2('course-common-error-catch', {
      err_msg: error && error.message,
      err_info: info && info.componentStack,
    })
  }

  render() {
    if (this.state.error) {
      // 渲染出错时的 UI
      return null
    }
    return <>{this.props.children}</>
  }
}
ErrorBoundary.propTypes = {
  children: oneOfType([arrayOf(node), node]),
}
export { ErrorBoundary }
export default ErrorBoundary
